export default __webpack_public_path__ + "static/media/vod-medium.22e5d14b.jpg";